export default __webpack_public_path__ + "static/media/lock.d198c2c3.svg";